module.exports = __webpack_public_path__ + "img/product4.d61d9c38.jpg";